import { setToken } from "../auth/authState";
import { setUser } from "../auth/user";
import http from "../../services/http";
import storage from "../../services/Storage";
import { setLoading } from "../auth/user";
import { showLoginLoader } from "../ui/loginUi";

import axios from "axios";

// (async () => {
//   console.log("Message in 5s");
//   const token = await getData("xAuthToken");

//   console.log("If you like it, show it");
// })();

// export const signup = ({ body, onSuccess, onError }) => {
//   return async (dispatch, getState) => {
//     try {
//       const res = await axios.post(
//         "https://envko-dev.herokuapp.com/api/public/user",
//         body
//       );
//       console.log("resssss=>", res);
//       const { data } = res;
//       console.log("data=>", data);
//       dispatch(setUser(data));
//       const { tokens } = data;
//       dispatch(setToken(tokens.token));
//       dispatch(setUser(data.user));

//       // await storeData("authState", tokens.token);
//       // await storeData("user", user);
//       // await storage.store("user", data.user);
//       onSuccess(res);
//     } catch (error) {
//       if (onError) onError(error);
//     }
//   };
// };

export const login = ({ body, onSuccess, onError }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(showLoginLoader(true));

      const res = await http.post("public/admin/auth", body);
      console.log("response in login===>", res.data);
      const { data } = res;
      const { token } = data;
      let user = data;

      dispatch(setToken(token));
      dispatch(setUser(data));

      storage.store("xAuthToken", token);
      // storage.store("user", user);

      onSuccess(res);
      dispatch(showLoginLoader(false));
    } catch (error) {
      dispatch(showLoginLoader(false));

      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
    }
  };
};
